import { Box, CircularProgress, Typography } from '@mui/material';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useBusinessContext } from '../context/BusinessContext';

/**
 * For non-admin routes: require at least one accessible business and a valid selected business.
 * Admin users bypass this gate.
 */
const RequireBusinessSelection = (): JSX.Element => {
  const { hasBookingAdmin } = useAuth();
  const { loading, businesses, hasValidSelection } = useBusinessContext();
  const location = useLocation();

  if (hasBookingAdmin()) {
    return <Outlet />;
  }

  if (loading) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center" minHeight="50vh">
        <CircularProgress />
      </Box>
    );
  }

  if (businesses.length === 0) {
    if (location.pathname === '/business') {
      return (
        <Box p={3}>
          <Typography color="text.secondary">
            Таны бүртгэлд хандах бизнес алга.
          </Typography>
        </Box>
      );
    }
    return <Navigate to="/business" replace />;
  }

  if (!hasValidSelection && location.pathname !== '/business') {
    return <Navigate to="/business" replace />;
  }

  return <Outlet />;
};

export default RequireBusinessSelection;

